
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[code]",
      function () {
        return require("private-next-pages/news/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[code]"])
      });
    }
  